import { render, staticRenderFns } from "./HomeRecepcionistaEspecial.vue?vue&type=template&id=cc6f7a00&scoped=true"
import script from "./HomeRecepcionistaEspecial.vue?vue&type=script&lang=js"
export * from "./HomeRecepcionistaEspecial.vue?vue&type=script&lang=js"
import style0 from "./HomeRecepcionistaEspecial.vue?vue&type=style&index=0&id=cc6f7a00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6f7a00",
  null
  
)

export default component.exports